export var Icons;

(function (Icons) {
  Icons["Add"] = "Add";
  Icons["AddPerson"] = "AddPerson";
  Icons["AgendaTime"] = "AgendaTime";
  Icons["ArrowLeft"] = "ArrowLeft";
  Icons["ArrowRight"] = "ArrowRight";
  Icons["Alert"] = "Alert";
  Icons["Clipboard"] = "Clipboard";
  Icons["Calendar"] = "Calendar";
  Icons["CalendarDots"] = "CalendarDots";
  Icons["CallEnd"] = "CallEnd";
  Icons["CameraOff"] = "CameraOff";
  Icons["CameraOn"] = "CameraOn";
  Icons["CameraTip"] = "CameraTip";
  Icons["Refresh"] = "Refresh";
  Icons["RefreshClock"] = "RefreshClock";
  Icons["CaretDown"] = "CaretDown";
  Icons["CaretUp"] = "CaretUp";
  Icons["Chat"] = "Chat";
  Icons["Check"] = "Check";
  Icons["Clock"] = "Clock";
  Icons["Close"] = "Close";
  Icons["MicrophoneOn"] = "MicrophoneOn";
  Icons["MicrophoneOff"] = "MicrophoneOff";
  Icons["NoReservation"] = "NoReservation";
  Icons["Options"] = "Options";
  Icons["OptionsHorizontal"] = "OptionsHorizontal";
  Icons["RefreshClockSuccess"] = "RefreshClockSuccess";
  Icons["Send"] = "Send";
  Icons["Settings"] = "Settings";
  Icons["Sofa"] = "Sofa";
  Icons["Wifi"] = "Wifi";
  Icons["Pen"] = "Pen";
  Icons["Trash"] = "Trash";
  Icons["ErrorIcon"] = "ErrorIcon";
  Icons["ExpandMore"] = "ExpandMore";
  Icons["ExpandLess"] = "ExpandLess";
  Icons["Clear"] = "Clear";
  Icons["Search"] = "Search";
  Icons["Plus"] = "Plus";
})(Icons || (Icons = {}));